import { render, staticRenderFns } from "./TypeSwitch.vue?vue&type=template&id=51c76a4f&scoped=true&"
import script from "./TypeSwitch.vue?vue&type=script&lang=js&"
export * from "./TypeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TypeSwitch.vue?vue&type=style&index=0&id=51c76a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c76a4f",
  null
  
)

export default component.exports